import React, { PropTypes } from 'react'
import VideoItem from './VideoItem'
import { VIDEOS } from "../../../data";

function Videos({ children, params }) {

  const getChildren = () => {
    const filteredVideos = VIDEOS.filter(video => video.url === params.id);

    if (typeof filteredVideos[0] === 'undefined') {
      return <div>Vidéo inexistante</div>;
    } else {
      return React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          video: filteredVideos[0]
        })
      });
    }
  };


  if (params.id) {


    return (
      <div className="row">
        <div className="col s12 m8 l8">
          {getChildren()}
        </div>
        <div className="col s12 m4 l4">
          <ul>
            <li><span className="other-videos">Autres vidéos</span></li>
            {VIDEOS.map(video => <li key={video.url}><VideoItem video={video} preview/>
            </li>)}
          </ul>
        </div>
      </div>
    );
  } else {

    return (
      <div className="row">
        <ul>
          {VIDEOS.map(video => <li key={video.url}><VideoItem video={video}/></li>)}
        </ul>
      </div>
    );
  }

}

const { node, object} = PropTypes
Videos.propTypes = {
  children: node,
  params: object
}

export default Videos



/** WEBPACK FOOTER **
 ** ./src/components/Media/Videos/Videos.jsx
 **/